module.exports = __webpack_public_path__ + "static/media/3.2b15de3f.jpg";